import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { PrimaryButon } from '@ui/components/common/button/PrimaryButon';
import { PageHeader } from '../../../components/common/header/PageHeader';
import React, { useEffect, useState } from 'react';
import { Edit, Eye, Import } from 'iconsax-react';
import { CustomChip } from '@ui/components/common/chip/Chip';
import { PrimaryGrid } from '@ui/components/common/grid/PrimaryGrid';
import { WidgetHeader } from '@ui/components/common/header/widgetHeader/WidgetHeader';
import CustomSelect from '@ui/components/common/inputs/CustomSelect';
import { months } from '@ui/constants/helper';
import { AddInvoice } from './modal/AddInvoice';
import { useAppDispatch } from '@application/store/useStore';
import { getAllInvoices } from '@application/features/invoices/invoiceThunk';
import { InvoiceStatusMap } from '@application/common/enums/invoice-status';
import { downloadCOCDocumentAsync } from '@application/features/freelancer/freelancerThunks';
import { convertBase64toBlob, getMimeTypeFromBase64 } from '@application/common/helpers/file-helper';
export const Invoices = () => {
    const currentDate = new Date();
    const [isAddInvoice, setIsAddInvoice] = useState(false);
    const [isEditInvoice, setIsEditInvoice] = useState(false);
    const currentMonthIndex = currentDate.getMonth() < 12 ? currentDate.getMonth() + 1 : currentDate.getMonth();
    const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear().toString());
    const [selectedMonth, setSelectedMonth] = useState(currentMonthIndex.toString());
    const [allInvoices, setAllIvoices] = useState([]);
    const [selectedRow, setSelectedRow] = useState('');
    const currentYear = currentDate.getFullYear();
    const monthOptions = months;
    const yearOptions = [
        { label: (currentYear - 1).toString(), value: (currentYear - 1).toString() },
        { label: currentYear.toString(), value: currentYear.toString() }
    ];
    const dispatch = useAppDispatch();
    const fetchInvoices = async (month, year) => {
        const getInvoiceRequestModel = {
            month,
            year
        };
        await dispatch(getAllInvoices(getInvoiceRequestModel))
            .unwrap()
            .then((resp) => {
            const formattedResp = resp.map((invoice) => ({
                ...invoice,
                totalAmount: parseFloat(invoice.totalAmount.replace('$', '')) // Remove $ and parse to number
                    .toLocaleString('nl', { maximumFractionDigits: 2 })
            }));
            setAllIvoices(formattedResp);
        })
            .catch((err) => {
            console.error(err);
        });
    };
    useEffect(() => {
        if (selectedYear && selectedMonth) {
            fetchInvoices(parseInt(selectedMonth), parseInt(selectedYear));
        }
    }, [selectedYear, selectedMonth, currentMonthIndex]);
    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };
    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };
    const handleActionClick = (rowData) => {
        if (InvoiceStatusMap.get(rowData.status) === 'Pending' || InvoiceStatusMap.get(rowData.status) === 'Rejected') {
            setSelectedRow(rowData.id);
            setIsEditInvoice(true);
        }
    };
    const DownloadApprovedInvoiceDocument = (rowData) => {
        const fileDto = { folderName: rowData?.folderName, fileName: rowData?.fileName };
        dispatch(downloadCOCDocumentAsync(fileDto))
            .unwrap()
            .then((res) => {
            const mimeType = getMimeTypeFromBase64(res.file);
            if (mimeType === 'application/pdf') {
                // Preview the PDF in a new tab
                const pdfWindow = window.open();
                if (!pdfWindow) {
                    console.error('Failed to open new window for PDF preview.');
                    return;
                }
                pdfWindow.document.write(`<title>${rowData?.fileName || 'Chamber of Commerce Document'}</title>`);
                pdfWindow.document.write(`<iframe width='100%' height='100%' src='data:${mimeType};base64,${encodeURIComponent(res.file)}'></iframe>`);
            }
            else {
                const blob = convertBase64toBlob(res.file, mimeType ?? '');
                if (!blob) {
                    console.error('Failed to create Blob from the base64 string.');
                    return;
                }
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = rowData?.fileName || 'download';
                link.click();
                URL.revokeObjectURL(url);
            }
        });
    };
    const updateSelectedYearAndMonth = (year, month) => {
        setSelectedYear(year);
        setSelectedMonth(month.toString());
        if (year === selectedYear && month.toString() === selectedMonth) {
            fetchInvoices(month, parseInt(year));
        }
    };
    const columns = [
        {
            field: 'invoiceNo',
            headerName: 'ID',
            flex: 1.5,
            minWidth: 100
        },
        {
            field: 'planName',
            headerName: 'Plan',
            flex: 1.3,
            minWidth: 110,
            renderCell: (params) => _jsx(CustomChip, { value: params.value })
        },
        {
            field: 'clientName',
            headerName: 'Client Name',
            flex: 1,
            minWidth: 200
        },
        {
            field: 'totalAmount',
            headerName: 'Amount',
            flex: 1,
            minWidth: 130
        },
        {
            field: 'month',
            headerName: 'Month',
            flex: 1,
            minWidth: 130
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1.3,
            minWidth: 130,
            renderCell: (params) => _jsx(CustomChip, { value: InvoiceStatusMap.get(params.value) })
        },
        {
            field: 'action',
            headerName: 'Action',
            headerAlign: 'left',
            align: 'left',
            flex: 1,
            minWidth: 130,
            renderCell: (params) => {
                const { status } = params.row;
                if (InvoiceStatusMap.get(status) === 'Pending') {
                    return (_jsx(IconButton, { onClick: () => handleActionClick(params.row), children: _jsx(Eye, {}) }));
                }
                else if (InvoiceStatusMap.get(status) === 'Rejected') {
                    return (_jsx(IconButton, { onClick: () => handleActionClick(params.row), children: _jsx(Edit, {}) }));
                }
                else if (InvoiceStatusMap.get(status) === 'Approved') {
                    return (_jsx(IconButton, { children: _jsx(Import, { onClick: () => DownloadApprovedInvoiceDocument(params.row) }) }));
                }
            }
        }
    ];
    return (_jsxs("div", { children: [_jsx(PageHeader, { title: 'Invoices', children: _jsx(Box, { width: 250, children: _jsx(PrimaryButon, { onClick: () => setIsAddInvoice(true), children: "Add Invoice" }) }) }), _jsx(Box, { pl: 2, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, md: 3, xs: 12, sm: 12, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 2, children: [_jsx(CustomSelect, { options: yearOptions, label: 'Year', selectedOption: selectedYear, handleChange: handleYearChange }), _jsx(CustomSelect, { options: monthOptions, label: 'Month', selectedOption: selectedMonth, handleChange: handleMonthChange })] }) }), _jsxs(Grid, { item: true, md: 9, xs: 12, sm: 12, children: [_jsx(WidgetHeader, { children: _jsx(Typography, { fontSize: '20px', color: '#FFFFFF', children: "All Invoices" }) }), _jsx(PrimaryGrid, { h: 'calc(100svh - 290px)', columns: columns, rows: allInvoices })] })] }) }), _jsx(AddInvoice, { open: isAddInvoice, type: 'add', handleClose: () => setIsAddInvoice(false), updateParentYearAndMonth: updateSelectedYearAndMonth }), _jsx(AddInvoice, { open: isEditInvoice, type: 'edit', handleClose: () => setIsEditInvoice(false), updateParentYearAndMonth: updateSelectedYearAndMonth, invoiceId: selectedRow })] }));
};
